import React, { useState, useRef } from 'react';
import Webcam from 'react-webcam';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setImageData } from '../redux-toolkit/slices/imageSlice';
import Signature from './Signature';

const SignaturePopup = ({ show, handleClose }) => {

 
  const [imageSrc, setImageSrc] = useState(null);
  const dispatch = useDispatch();



  
 

  return (
    <>

      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Take Signature</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Signature  handleCloseSignature={handleClose}/>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {imageSrc && (
        <div>
          <h2>Captured Image:</h2>
          <img src={imageSrc} alt="Captured" />
        </div>
      )} */}
    </>
  );
};


export default SignaturePopup;

